export default __webpack_public_path__ + "images/ccf145c936454495769e08e602a92412-arts.webp";